// src/slices/shipessitional/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getShipTrafficAll } from "./thunk";

const initialState = { shipTrafficAll: [], loading: false, error: null };

const shipTrafficAllSlice = createSlice({
  name: "shipTrafficAll",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getShipTrafficAll.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getShipTrafficAll.fulfilled, (state, action) => {
        state.loading = false;
        state.shipTrafficAll = action.payload?.data;
      })

      .addCase(getShipTrafficAll.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default shipTrafficAllSlice.reducer;
